module.exports = __webpack_public_path__ + "img/login2.98178cd6.svg";